import styled, { css } from 'styled-components/macro';
import { colorCoreBlack300, colorCoreBackground1000, colorCoreBlack900Base, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { ADAPTIVE } from '@yme/tokens/screen';
import { getTextStyles } from '@yme/utils/styles';
export const TableWrapperStyled = styled.table `
  border: none;
  border-collapse: collapse;
  width: 100%;
`;
const TableCellCommonStyles = css `
  ${getTextStyles('Ubuntu', 400, 16, 24)}

  color: ${colorCoreBlack300};

  overflow-wrap: anywhere;
  padding: 10px 16px;
  text-align: left;

  &:first-child {
    border-bottom-left-radius: ${CORNER_RADIUS.xs};
    border-top-left-radius: ${CORNER_RADIUS.xs};
  }

  &:last-child {
    border-bottom-right-radius: ${CORNER_RADIUS.xs};
    border-top-right-radius: ${CORNER_RADIUS.xs};
  }

  width: ${({ cellWidth }) => cellWidth?.sm || '50%'};

  ${({ isRightToLeft }) => isRightToLeft && 'text-align: right;'}

  ${ADAPTIVE.minWidth.tablet} {
    overflow-wrap: break-word;
    word-break: initial;

    width: ${({ cellWidth }) => cellWidth?.md || 'auto'};
  }

  ${ADAPTIVE.minWidth.desktop} {
    width: ${({ cellWidth }) => cellWidth?.lg || 'auto'};
  }

  ${({ cellPadding }) => cellPadding && `padding: ${cellPadding};`}
`;
export const TableCellStyled = styled.td `
  ${TableCellCommonStyles};
`;
export const TableHeadCellStyled = styled.th `
  ${TableCellCommonStyles};
  ${getTextStyles('Ubuntu', 500, 16, 24)}
  color: ${colorCoreBlack900Base};
`;
export const TableCellHeadingStyled = styled.span `
  ${getTextStyles('Ubuntu', 500, 16, 24)}

  color: ${colorCoreBlack900Base};
`;
export const TableRowStyled = styled.tr `
  &:nth-child(2n + 1) {
    background-color: ${colorCoreBackground1000};
  }
`;
export const TableBodyStyled = styled.tbody ``;
export const TableHeadStyled = styled.thead ``;
